import styled from '@emotion/styled';
import { media } from '../../../services/media';
import React, { useCallback } from 'react';

interface ProfileDataSourceProps {
    name: string;
    image: string;
    idSource: string;
    buttonTitle?: string;
    onClick: (idSource: string) => void;
}

export const ProfileDataSource: React.FC<ProfileDataSourceProps> = ({
    name,
    image,
    idSource,
    buttonTitle,
    onClick,
}) => {
    const handleClick = useCallback(
        (e) => {
            e.preventDefault();
            onClick(idSource);
        },
        [onClick, idSource],
    );

    return (
        <Datasource>
            {image && name && (
                <ImageWrapper>
                    <Image src={`/assets/images/${image}`} alt={name} />
                </ImageWrapper>
            )}

            {buttonTitle && (
                <ButtonWrapper>
                    <Button type="button" onClick={handleClick}>
                        {buttonTitle}
                    </Button>
                </ButtonWrapper>
            )}
        </Datasource>
    );
};

const Datasource = styled.div`
    flex: 1;
`;

const ImageWrapper = styled.figure`
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    justify-content: center;

    height: 180px;
    padding: 0;

    margin: 0;
`;

const Image = styled.img`
    display: block;
    max-height: 100%;
    object-fit: cover;
`;

const ButtonWrapper = styled.div`
    display: block;

    margin-top: 20px;

    text-align: center;

    ${media.min('lg')} {
        margin-top: 40px;
    }
`;

const Button = styled.button`
    padding: 0;

    font-size: 20px;
    font-weight: 300;

    border: none;
    background: none;
    cursor: pointer;

    ${media.min('lg')} {
        font-size: 30px;
    }
`;
